import { Link } from 'react-router-dom';

export function HubBackLink({
  to,
  label = 'Volver',
  onBack,
}: {
  to?: string;
  label?: string;
  onBack?: () => void;
}) {
  const className =
    'lib-index-back flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-dash-outline-variant bg-white text-dash-on-surface-variant transition-colors hover:bg-secondary-100';
  const icon = (
    <span className="material-symbols-outlined text-[1.35rem]" aria-hidden="true">
      arrow_back
    </span>
  );

  if (onBack) {
    return (
      <button type="button" className={className} aria-label={label} onClick={onBack}>
        {icon}
      </button>
    );
  }

  return (
    <Link to={to ?? '/'} className={className} aria-label={label}>
      {icon}
    </Link>
  );
}
